import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Vehicle selector',
  name: 'vehicleSelector',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      initialValue: 'Shop by vehicle',
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare({ title }) {
      return {
        title: title || 'Shop by vehicle',
        subtitle: 'Vehicle selector',
      }
    },
  },
})